import(/* webpackMode: "eager" */ "/app/src/app/(site)/error.tsx");
